import { IHttp, IRxHttp } from './IHttp';
import { XhrHttp, XhrHttpRetryOptions } from './XhrHttp';
// import { AxiosHttp } from "./AxiosHttp";
// import { FetchHttp } from "./FetchHttp";

export class HttpFactory {
    constructor(private baseUrl: string) {
    }

    createHttp(options?: Partial<XhrHttpRetryOptions>): IHttp {
        return new XhrHttp(this.baseUrl, undefined, options);
        // return new AxiosHttp(this.baseUrl);
        // return new FetchHttp(this.baseUrl);
    }
    createRxHttp(): IRxHttp {
        return new XhrHttp(this.baseUrl);        
    }
}